import React, { useEffect, useState } from 'react'
import { Pannellum } from "pannellum-react";
import myImage from "../image/milan.jpg";
import { useDispatch, useSelector } from 'react-redux';
import { fetchPanorama } from '../redux/action/expo/panorama';
import default_image_url from '../redux/api/API'
import MainLoading from '../utils/MainLoading';

const ExhibitionId = (props) => {
    const [spots, setSpots] = useState([])

    const panorama = useSelector(state => state.panorama)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchPanorama())
    }, [])

    useEffect(() => {
        if (panorama.panorama.length) {
            setSpots(panorama.panorama.filter(pan => pan.id === parseInt(props.match.params.id))[0].actions)
        }   
    }, [panorama.panorama])

    return (
        <div>
            
        {panorama.loading ?
            <MainLoading />
        : 
            panorama.panorama.length &&
            <Pannellum
                width="100%"
                height="100vh"
                image={myImage}
                pitch={10}
                yaw={140}
                hfov={140}
                autoLoad
            >
                {spots.map(spot => (
                    <Pannellum.Hotspot
                        key={spot.id}
                        type="info"
                        pitch={spot.x_axis}
                        yaw={spot.y_axis}
                        text={spot.title}
                        URL={spot.type === "saloon" ? `/saloon-exhibition/${spot.type_id}` : `/exhibition/${spot.type_id}` }
                    />
                ))}

            </Pannellum>
        }
        </div>
    )
}

export default ExhibitionId
